import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { getAdjacent } from '../data/blog';

const Root = styled.nav`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const Tile = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.3rem;
  height: 100%;
  min-height: 64px;
  padding: 1rem;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
  background: var(--surface);
  transition: background-color 0.18s ease, border-color 0.18s ease, transform 0.18s ease;

  &:hover {
    background: var(--surface-hover);
    border-color: var(--border-strong);
    transform: translateY(-2px);
  }
`;

const Label = styled.span`
  font-size: var(--fs-eyebrow);
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-3);
`;

const Name = styled.span`
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--text-1);
  line-height: 1.2;
`;

const COPY = {
  en: { nav: 'More posts', newer: 'Newer', older: 'Older' },
  es: { nav: 'Más artículos', newer: 'Más reciente', older: 'Más antiguo' },
};

const PostNav: React.FC<{ slug: string; lang?: string }> = ({ slug, lang = 'en' }) => {
  const { newer, older } = getAdjacent(slug);
  if (!newer && !older) return null;
  const copy = COPY[lang === 'es' ? 'es' : 'en'];

  return (
    <Root aria-label={copy.nav}>
      {newer ? (
        <Tile to={`/blog/${newer.slug}`}>
          <Label>{copy.newer}</Label>
          <Name>{newer.title}</Name>
        </Tile>
      ) : (
        <div />
      )}
      {older ? (
        <Tile to={`/blog/${older.slug}`}>
          <Label>{copy.older}</Label>
          <Name>{older.title}</Name>
        </Tile>
      ) : (
        <div />
      )}
    </Root>
  );
};

export default PostNav;
